import {
    SET_NAVIGATION_LOCK,
    CLEAR_NAVIGATION_LOCK
} from './actions';

const defaultState = () => ({
    message: '',
    isLocked: false,
    pendingNavigation: null
});

const state = defaultState();

const mutations = {
    [SET_NAVIGATION_LOCK](state, { message, pendingNavigation } = {}) {
        state.isLocked = true;

        if (message !== undefined) {
            state.message = message;
        }
        if (pendingNavigation !== undefined) {
            state.pendingNavigation = pendingNavigation;
        }
    },
    [CLEAR_NAVIGATION_LOCK](state) {
        Object.assign(state, defaultState());
    }
};

const getters = {
    isNavigationLockActive: state => state.isLocked,
    navigationLockMessage: state => state.message,
    navigationLockPendingNavigation: state => state.pendingNavigation
};

export default {
    state,
    mutations,
    getters
};
